export default {
	about_the: 'Sobre las',
	company_agency: 'Plataforma a la que desea acceder:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explore todo o nosso universo de cursos, vídeos, artigos e arquivos.',
	project_name: 'Programa Inwictus',
	welcome_to: 'Bienvenido(a) la',
}
